/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ConstructionDayReport } from '../../models/construction-day-report';

export interface ApiV0ConstructiondayreportUpdateConstructionDayReportPost$Json$Params {
      body?: ConstructionDayReport
}

export function apiV0ConstructiondayreportUpdateConstructionDayReportPost$Json(http: HttpClient, rootUrl: string, params?: ApiV0ConstructiondayreportUpdateConstructionDayReportPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, apiV0ConstructiondayreportUpdateConstructionDayReportPost$Json.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<string>;
    })
  );
}

apiV0ConstructiondayreportUpdateConstructionDayReportPost$Json.PATH = '/api/v0/constructiondayreport/updateConstructionDayReport';
